<template
  ><v-card class="p-4">
    <v-card-title>
      Contenus envoyés par les clients
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Rechercher sur les noms, dates ..."
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="videoToUpload"
      :search="search"
      :items-per-page="12"
      :page.sync="pagination.currentPage"
      hide-default-footer
    >
      <template v-slot:item.createdAt="{ item }">
        <span>{{ item.createdAt|moment }}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small @click="deleteVideoToUpload(item)">
          mdi-delete
        </v-icon>

        <a :href="apiUrl + item.video">
          <v-icon small>
            mdi-download
          </v-icon>
        </a>
      </template>
    </v-data-table>

    <v-pagination
      v-model="pagination.currentPage"
      :length="pagination.pagesNumber"
      @input="onPageChange"
    ></v-pagination>
  </v-card>
</template>

<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";
import moment from "moment";


export default {
  name: "listVideosClient",
  data() {
    return {
      confirmDelete: false,
      loading: true,
      options: {},
      search: "",
      headers: [
        { text: "Nom du dossier", value: "videoPath", align: "start" },
        { text: "Nom du client", value: "user.client.name", align: "start" },
        { text: "Envoyé le", value: "createdAt", align: "start" },

        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],
      videoToUpload: [],
      pagination: {
        currentPage: 1,
        pagesNumber: 0,
      },
      deletedIndex: -1,
    };
  },
  filters: {
    moment: function(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },

  methods: {
    getAllVideoToUpload() {
      this.loading = true;

      Api.get("video_to_uploads?page=" + this.pagination.currentPage).then(
        (videosToUpload) => {
          this.videoToUpload = videosToUpload.data["hydra:member"];
          this.pagination.pagesNumber = Math.ceil(
            videosToUpload.data["hydra:totalItems"] / 12 //12 car côté API le nombre de videos est réglé a 12 par page
          );
          this.loading = false;
        }
      );
    },
    onPageChange() {
      //Pagination
      this.getAllVideoToUpload();
    },
    deleteVideoToUpload(item) {
      Swal.fire({
        title: "Voulez-vous vraiment supprimer ce dossier ?",
        text: "Attention, cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer le dossier",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletedIndex = this.videoToUpload.indexOf(item);
          Api.delete("video_to_uploads/" + item.id).then(() => {
            this.videoToUpload.splice(this.deletedIndex, 1),
              Swal.fire("Supprimé !", "Le dossier à été supprimé", "success"),
              this.getAllVideoToUpload();
          });
        }
      });
    },
  },
  mounted() {
    this.getAllVideoToUpload();
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API;
    },
  },
};
</script>
